import gql from "graphql-tag";

export const uploadedProfilePicture = gql`
mutation UploadedProfilePicture(
  $input: String) {
    uploadedProfilePicture(input: $input) {
      user {
        id
        firebaseId
        profilePictureUrl
      }
    }
  }
`;

export const uploadedProfilePictureOptions = {
  name: "uploadedProfilePicture",
};
